import React, { useContext, useEffect, useRef, useState } from "react";
import "./Testimonials.css";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
// import { Context } from "../../../../utils/context";
import { Context } from "../../../../utils/context";
import Common_Title from "../../../common_components/common_title/Common_Title";

const Testimonials = () => {
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();
  const { getData, imageUrl } = useContext(Context);

  const [clientReviews, setClientReview] = useState();

  const getClientReview = async () => {
    const res = await getData("/without-login/home/client-review");
    if (res?.success) {
      
      setClientReview(res.data);
    }
  };

  useEffect(() => {
    getClientReview();
  }, []);

  return (
    <>
      <div className="Testimonials_section">
        <div className="container">
          <div className="test_title text-center mb-4">
            {/* <h2 className="ttttt">Good Reviews By Clients</h2> */}
            <Common_Title title="Good Reviews " subTitle={"By Clients"}/>
          </div>
          <Swiper
            slidesPerView={1}
            spaceBetween={10}
            pagination={{
              clickable: true,
            }}
           
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            loop={true}
            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              575: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              991: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              1400: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
            }}
            modules={[Pagination, Autoplay]}
            className="mySwiper"
          >
            {clientReviews?.map((job, index) => (
              <SwiperSlide>
                <div className="slider_div">
                  <div className="row">
                    <div className="col-sm-3 col-4">
                      <div className="img_div">
                        <img
                          src={imageUrl + job?.image}
                          className="slide_img"
                          alt="..."
                        />
                      </div>
                    </div>
                    <div className="col-sm-9 col-8">
                      <p className="Review_slider-txt1">
                        {htmlToReactParser.parse(job?.description)}
                      </p>
                      <p className="slider_below_txt1">-{job?.name}</p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default Testimonials;
